import React from 'react';
import './index';

export default class Input extends React.Component {
    constructor(props) {
        super(props);

        this.state = { floating: props.value && props.value.length > 0 };

        this.onFocus = this.onFocus.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.onChange = this.onChange.bind(this);
    }

    onFocus(e) {
        this.setState({ floating: true });
        if (this.props.onFocus) {
            this.props.onFocus(e);
        }
    }

    onBlur(e) {
        this.setState({ floating: e.target.value && e.target.value.length > 0 });
        if (this.props.onBlur) {
            this.props.onBlur(e);
        }
    }

    onChange(e) {
        // this.setState({ floating: this.props.value && this.props.value.length > 0 });
        if (this.props.onChange) {
            this.props.onChange(e);
        }
    }

    render() {
        const props = this.props;
        const className = props.className || '';
        const errorClassName = props.valid === undefined ? '' : props.valid ? '' : 'error';
        const floatingClassName = this.state.floating ? 'floating' : '';

        return props.floating ? (
            <div className="floating-label">
                <input
                    id={props.id}
                    className={`inp ${className} ${errorClassName}`}
                    type={props.type || 'text'}
                    value={props.value}
                    onChange={this.onChange}
                    onFocus={this.onFocus}
                    onBlur={this.onBlur}
                    onClick={e => props.onClick && props.onClick(e)}
                    onKeyDown={e => props.onKeyDown && props.onKeyDown(e)}
                    placeholder={props.placeholder}
                    autoComplete={props.autoComplete ? props.autoComplete : 'off'}
                    maxLength={props.maxLength}
                    inputMode={props.inputMode || 'text'}
                    readOnly={props.readonly || false}
                    disabled={props.disabled ? 'disabled' : ''}
                />
                {props.label && <p className={`inp-label ${floatingClassName}`}>{props.label}</p>}
            </div>
        ) : (
            <div className="static-label">
                {props.label && (
                    <label htmlFor={props.id} className="inp-label">
                        {props.label}
                    </label>
                )}
                <input
                    id={props.id}
                    className={`inp ${className} ${errorClassName} `}
                    type={props.type || 'text'}
                    value={props.value}
                    onChange={e => props.onChange && props.onChange(e)}
                    onFocus={e => props.onFocus && props.onFocus(e)}
                    onBlur={e => props.onBlur && props.onBlur(e)}
                    onClick={e => props.onClick && props.onClick(e)}
                    onKeyDown={e => props.onKeyDown && props.onKeyDown(e)}
                    placeholder={props.placeholder}
                    autoComplete={props.autoComplete ? props.autoComplete : 'off'}
                    maxLength={props.maxLength}
                    inputMode={props.inputMode || 'text'}
                    readOnly={props.readonly || false}
                    disabled={props.disabled ? 'disabled' : ''}
                />
            </div>
        );
    }
}
